<template>
  <div class="pos-cate">
    <el-input
      v-model="keyword"
      size="mini"
      :placeholder="'输入人员名称'"
      @input="searchMember"
    >
    </el-input>
    <div v-if="keyword" class="pos-cate-drop el-select-dropdown el-popper" x-placement="bottom-start">
      <div x-arrow="" class="popper__arrow" style="left: 35px;"></div>
      <div class="pos-cate-drop-item">
        <div>您要搜索的是:<span>（默认全部包含）</span></div>
      </div>
      <div class="pos-cate-drop-box">
        <div class="pos-cate-drop-item">
          <div class="drop-label">客户开发:</div>
          <div class="drop-content">
            <div v-if="matchAccounts.length> 0">
              <el-checkbox-group v-model="dropData.客户开发">
                <el-checkbox v-for="(v, k) in matchAccounts" :key="k" :label="v"></el-checkbox>
              </el-checkbox-group>
            </div>
            <span v-else>无</span>
          </div>
        </div>
        <div class="pos-cate-drop-item">
          <div class="drop-label">项目对接:</div>
          <div class="drop-content">
            <div v-if="matchAccounts.length> 0">
              <el-checkbox-group v-model="dropData.项目对接">
                <el-checkbox v-for="(v, k) in matchAccounts" :key="k" :label="v"></el-checkbox>
              </el-checkbox-group>
            </div>
            <span v-else>无</span>
          </div>
        </div>
        <div class="pos-cate-drop-item">
          <div class="drop-label">项目经理:</div>
          <div class="drop-content">
            <div v-if="matchAccounts.length> 0">
              <el-checkbox-group v-model="dropData.项目经理">
                <el-checkbox v-for="(v, k) in matchAccounts" :key="k" :label="v"></el-checkbox>
              </el-checkbox-group>
            </div>
            <span v-else>无</span>
          </div>
        </div>
        <div class="pos-cate-drop-item">
          <div class="drop-label">项目成员:</div>
          <div class="drop-content">
            <div v-if="matchAccounts.length> 0">
              <el-checkbox-group v-model="dropData.项目成员">
                <el-checkbox v-for="(v, k) in matchAccounts" :key="k" :label="v"></el-checkbox>
              </el-checkbox-group>
            </div>
            <span v-else>无</span>
          </div>
        </div>
        <div v-if="showWeihu" class="pos-cate-drop-item">
          <div class="drop-label">客户维护:</div>
          <div class="drop-content">
            <div v-if="matchAccounts.length> 0">
              <el-checkbox-group v-model="dropData.客户维护">
                <el-checkbox v-for="(v, k) in matchAccounts" :key="k" :label="v"></el-checkbox>
              </el-checkbox-group>
            </div>
            <span v-else>无</span>
          </div>
        </div>
      </div>
      <div style="padding-top: 5px;text-align:right">
        <div class="radish-btn radish-btn-primary" @click="handleConfirm">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    ignore: { type: Array, default: () => [] },
    showCategoryDetail: { type: Boolean, default: true },
    showWeihu: { type: Boolean, default: false },
  },
  data() {
    return {
      keyword: '',
      dropData: {
        客户开发: [],
        项目对接: [],
        项目经理: [],
        项目成员: [],
        客户维护: [],
      },
      matchAccounts: [],
    }
  },
  methods: {
    async searchMember(keyword) {
      if (!this.keyword) return
      if (!app.accounts) await app.getUsers()
      const accounts = app.accounts
      const matchAccounts = []
      accounts.forEach(account => {
        const reg = new RegExp(this.keyword, 'i')
        if (reg.test(account)) matchAccounts.push(account)
      })
      this.matchAccounts = matchAccounts
    },
    handleConfirm() {
      let arr = []
      Object.keys(this.dropData).forEach(k => {
        const v = this.dropData[k] || []
        if (v.length > 0) {
          v.forEach(val => arr.push({ type: k, value: val, label: `${k}:${val}` }))
        }
      })
      if (!this.showWeihu) arr = arr.filter(a=>a.type !== '客户维护')
      if (arr.length > 0) this.$emit('confirm', arr)
      else {
        const result = this.matchAccounts.map(val => ({ type: '全部', value: val, label: `全部:${val}` }))
        this.$emit('confirm', result)
      }
      this.keyword = ''
      this.dropData = {
        客户开发: [],
        项目对接: [],
        项目经理: [],
        项目成员: [],
        客户维护: [],
      }
    },
  },
}
</script>
<style>
.pos-cate {
  position: relative;
  width: 100%;
}
.pos-cate-drop {
  padding: 10px;
}
.pos-cate-drop-box{
  max-height: 500px;
  overflow: auto;
}
.pos-cate-drop-item {
  display: flex;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
  color: #606266;
}
.pos-cate-drop-item .drop-label {
  min-width: 60px;
}
.pos-cate-drop-item .drop-content {
  padding-left: 5px;
}
.drop-content-highlight {
  color: #409eff;
}
</style>
